import { defineMessages } from "react-intl";

const VALIDATION_WARNING = "validation-warning";

const validationWarningMessages = defineMessages({
  mergeAccountAlert: {
    id: `${VALIDATION_WARNING}.merge-account-alert`,
    defaultMessage: "Merge account alert"
  },
  foundFollowingIssues: {
    id: `${VALIDATION_WARNING}.found-following-issues`,
    defaultMessage:
      "We`ve found the following issues. These won't prevent you from merging your user account data."
  },
  continueWithMerge: {
    id: `${VALIDATION_WARNING}.continue-with-merge`,
    defaultMessage: "Continue with merge"
  }
});

export default validationWarningMessages;
